import React from "react";
import { CampaignData } from "../../types";
import { EmailContentCreation } from "./email-content-creation";
import { SmsContentCreation } from "./sms/sms-content-creation";
import VoiceBroadcast from "./broadcast";
import { SingleCampaignResponse } from "../../../views/marketing-pages/campaign/types";
import Broadcast from "./sms/Broadcast";
import { RcsContentCreation } from "./rcs/rcs-content-creation";

interface CampaignAiProps {
  campaignData: CampaignData;
  singleCampaign: SingleCampaignResponse | null;
  setCampaignData: React.Dispatch<React.SetStateAction<CampaignData>>;
  onSubmit: (data: Partial<CampaignData>) => void;
  onValidation: (isValid: boolean) => void;
  onBack: () => void;
}

export const AIContentCreation: React.FC<CampaignAiProps> = ({
  campaignData,
  singleCampaign,
  setCampaignData,
  onSubmit,
  onValidation,
  onBack,
}) => {
  switch (campaignData.campaign_channel) {
    case "sms":
      return (
        <SmsContentCreation
          campaignData={campaignData}
          singleCampaign={singleCampaign}
          setCampaignData={setCampaignData}
          onSubmit={onSubmit}
          onValidation={onValidation}
          onBack={onBack}
        />
      );

    case "email":
      return (
        <EmailContentCreation
          campaignData={campaignData}
          setCampaignData={setCampaignData}
          onSubmit={onSubmit}
          onValidation={onValidation}
          onBack={onBack}
        />
      );

    case "voice":
      return (
        <VoiceBroadcast
          campaignData={campaignData}
          setCampaignData={setCampaignData}
          onSubmit={onSubmit}
          onValidation={onValidation}
        />
      );

    case "whatsapp":
      return (
        <Broadcast
          campaignData={campaignData}
          setCampaignData={setCampaignData}
          onSubmit={onSubmit}
          onValidation={onValidation}
          onBack={onBack}
          singleCampaign={singleCampaign}
        />
      );

    case "rcs":
      return (
        <RcsContentCreation
          campaignData={campaignData}
          singleCampaign={singleCampaign}
          setCampaignData={setCampaignData}
          onSubmit={onSubmit}
          onValidation={onValidation}
          onBack={onBack}
        />
      );

    default:
      return null;
  }
};
